module.exports = __webpack_public_path__ + "static/media/fire.ed8a2aed.png";